// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"b7e45d8f","392":"b7e45d8f"}[chunkId] + ".chunk.css";
};